import React, { Fragment } from 'react';
import FbSalesReport from './FbSalesReport';

// Thin route entry — the V3 shell lives inside the view.
const FbSalesSummary = () => (
    <Fragment>
        <FbSalesReport />
    </Fragment>
);

export default FbSalesSummary;
